import React, { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Text,
    useToast
} from '@chakra-ui/react';

const BlockUserModal = ({ isOpen, onClose, user }) => {
    const toast = useToast();
    const [loading, setLoading] = useState(false);

    const handleBlock = () => {
        setLoading(true);
        // Simulate API call
        setTimeout(() => {
            setLoading(false);
            toast({
                title: 'User Blocked',
                description: `${user.username} has been blocked successfully.`,
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
            onClose();
        }, 1500);
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Block User</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text>
                        Are you sure you want to block <strong>{user?.username}</strong>?
                    </Text>
                    <Text mt={2} fontSize="sm" color="gray.500">
                        This user will no longer be able to log in or access the system.
                    </Text>
                </ModalBody>

                <ModalFooter>
                    <Button colorScheme="red" mr={3} onClick={handleBlock} isLoading={loading}>
                        Block User
                    </Button>
                    <Button variant="ghost" onClick={onClose}>Cancel</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default BlockUserModal;
